import React, { useContext } from "react";
import { SdfExpandableBox, SdfBadge, SdfButton } from "@waypoint/react-components";

import { AssistContext } from "./AssistProvider";
import AssistIcon from "./AssistIcon";
import AssistTextArea from "./AssistTextArea";
import "./Assist.scss";

const AssistBox = () => {
  const { boxOpen, setBoxOpen, setModalOpen } = useContext(AssistContext);

  return (
    <div className="flex gap-4">
    <SdfExpandableBox
      opened={boxOpen}
      onSdfClose={() => setBoxOpen(false)}
      onSdfOpen={() => setBoxOpen(true)}
      triggerPlacement="after"
      variant="shadowed"
      className="flex-grow"
    >
      <div slot="header" className="flex gap-4 items-center">
        <AssistIcon />
        <span className="text-heading-03">
          Find, activate and troubleshoot APIs with <span className="AssistRed">ADP Assist</span>
        </span>
        <SdfBadge status="new" className="text-body-01">New</SdfBadge>
      </div>
      <div className="flex flex-col gap-2 m-4 px-8 pt-4 bg-alert-info-50 rounded-b-lg">
        <div className="text-heading-04">Ask me anything about APIs</div>
        <AssistTextArea />
      </div>
    </SdfExpandableBox>
      <div className="mt-4">
        <SdfButton emphasis="primary" size="sm" onClick={() => setModalOpen(true)}>
          Chat
        </SdfButton>
      </div>
    </div>
  );
};

export default AssistBox;
